import React, { useState, useEffect } from "react";
import styles from "./SingleInvoiceMobile.module.css";
import { NavLink, useParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../context/auth";

import backbutton from "../../assets/icons/backbutton.png";
import logo from "../../assets/images/logo.png";
import FooterMobile from "../FooterMobile/FooterMobile";

const SingleInvoiceMobile = () => {
  const MAIN_URL = process.env.REACT_APP_URL

  const { user } = useAuth();
  const { id } = useParams();

  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedProductIndex, setSelectedProductIndex] = useState(0);

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const token = localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const response = await axios.get(
          `${MAIN_URL}/api/invoice/singleInvoice/${id}`,
          config
        );
        setInvoice(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching invoice:", error);
        setLoading(false);
      }
    };
    fetchInvoice();
  }, [id]);

  // To handle click on an image
  const handleImageClick = (index) => {
    setSelectedProductIndex(index);
  };
  if (loading) {
    return <div>Loading...</div>;
  }

  if (!invoice) {
    return <div>Invoice not found</div>;
  }

  return (
    <>
      <div className={styles.singleinvoice_page}>
        <div className={styles.singleinvoice_headContainer}>
          <img className={styles.header_image} src={logo} alt="logo " />
          <div className={styles.header_text}>Musicart</div>
        </div>
        <div className={styles.singleinvoice_mainContainer}>
          {/* BACK BUTTON  */}
          <div className={styles.product_back_btn}>
            <NavLink to="/home">
              <button className={styles.back_btn}>
               
                <img src={backbutton} alt="" />
              </button>
            </NavLink>
          </div>
          {/* HEADING */}
          <div className={styles.main_heading}>
            <h2>Invoice</h2>
          </div>
          <div className={styles.container}>
            {/* LEFT SIDE */}
            <div className={styles.left_container}>
              {/* address details  */}
              <div className={styles.address_section}>
                <p className={styles.address_heading}>1. Delivery address</p>
                <div className={styles.address_details}>
                  <span className={styles.user_name}> {user.name}</span>
                  <span className={styles.user_address}>{invoice.address}</span>
                </div>
              </div>
              <div className={styles.line1}></div>
              {/* payment details */}
              <div className={styles.payment_section}>
                <p className={styles.payment_heading}>2. Payment method</p>
                <div className={styles.payment_details}>
                  <p className={styles.payment_mode}>{invoice.paymentMethod}</p>
                </div>
              </div>
              <div className={styles.line2}></div>

              {/* review section  */}
              <div className={styles.review_section}>
                <p className={styles.review_heading}>
                  3. Review items and delivery
                </p>
                <div className={styles.review_details}>
                  {/* image section */}
                  <div className={styles.image_section}>
                    {invoice.products.map((product, index) => (
                      <img
                        key={index}
                        src={product.imgUrl}
                        alt={product.productName}
                        onClick={() => handleImageClick(index)}
                      />
                    ))}
                  </div>
                  {/* short details  */}
                  {selectedProductIndex !== null && (
                    <div className={styles.short_details_section}>
                      <p className={styles.product_name}>
                        {invoice.products[selectedProductIndex].productName}
                      </p>
                      <p className={styles.product_color}>
                        Color: {invoice.products[selectedProductIndex].color}
                      </p>
                      <p className={styles.delivery_time}>
                        <span>Delivery : Monday — FREE Standard Delivery</span>
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.line3}></div>
            </div>

            {/* RIGHT SIDE  */}

            <div className={styles.right_container}>
              <div className={styles.order_summary}>
                <p className={styles.summary_heading}>Order Summary</p>
                <div className={styles.item_cost}>
                  <span>Items : </span>
                  <span>₹{invoice.totalPrice.toFixed(2)}</span>
                </div>
                <div className={styles.delivery_cost}>
                  <span>Delivery : </span>
                  <span>₹45.00</span>
                </div>
              </div>
              <div className={styles.line4}></div>

              <div className={styles.total_order_details}>
                <p className={styles.total_order_text}>Order Total : </p>
                <p className={styles.total_order_cost}>
                 
                  ₹{invoice.totalPrice + 45}
                </p>
              </div>
            </div>
          </div>
        </div>
        <FooterMobile />
      </div>
    </>
  );
};

export default SingleInvoiceMobile;
